import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import { NAV_LINKS, SERVER_IP, DISCORD_URL } from "@/data/site";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-[#1b4d22]/40 bg-[#0c110d] mt-20"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Leaf className="w-6 h-6 text-[#d4af37]" />
            <span className="font-heading font-bold text-xl uppercase text-white">
              La Giungla <span className="text-[#d4af37]">SMP</span>
            </span>
          </div>
          <p className="text-sm text-[#9fb0a3] max-w-xs leading-relaxed">
            Il survival italiano definitivo. Un mondo persistente dove ogni
            blocco che piazzi conta.
          </p>
        </div>

        <div>
          <h4 className="font-heading uppercase text-[#d4af37] tracking-widest text-sm mb-4">
            Naviga
          </h4>
          <ul className="space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  className="text-sm text-[#e0e0e0] hover:text-[#d4af37] transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading uppercase text-[#d4af37] tracking-widest text-sm mb-4">
            Connettiti
          </h4>
          <p className="text-sm text-[#e0e0e0] mb-1">
            IP: <span className="text-[#d4af37] font-medium">{SERVER_IP}</span>
          </p>
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#e0e0e0] hover:text-[#d4af37] transition-colors"
          >
            Server Discord Ufficiale →
          </a>
        </div>
      </div>
      <div className="border-t border-[#1b4d22]/30 py-5 text-center text-xs text-[#6f7d72]">
        © {new Date().getFullYear()} La Giungla SMP · Non affiliato con Mojang
        AB. Tutti gli acquisti sono conformi all'EULA di Mojang.
      </div>
    </footer>
  );
};
